import { render, staticRenderFns } from "./arrow24.vue?vue&type=template&id=ac5ead4e&"
import script from "./arrow24.vue?vue&type=script&lang=js&"
export * from "./arrow24.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports